module.exports = __webpack_public_path__ + "public/images/slider/Muradyan.f9eb41586880206917531a45b28fa080.jpg";